import { LineKinds, Color, LineStyle } from "../../drawing";
import { AbstractPointsItem } from "./AbstractPointsItem";
import { ILineDrawable } from "./ILineDrawable";
import { TypeKeys } from "./TypeKeys";

export class PolylineItem extends AbstractPointsItem implements ILineDrawable {
  constructor() {
    super(TypeKeys.PolylineItem);
  }

  public lineStyle: LineStyle = new LineStyle(new Color("#000000"), LineKinds.Normal, 2);

  protected createCloneInstance(): PolylineItem {
    return new PolylineItem();
  }

  protected applyMembers(clone: PolylineItem): void {
    super.applyMembers(clone);
    clone.lineStyle = this.cloneValue(this.lineStyle);
  }
}
